import type { PricingStrategyProfileResponse } from '@/shared/api';
import { profileValues, row, type ProfileComparisonSection } from './profileComparisonModel';

export function buildPolicySection(
  profiles: PricingStrategyProfileResponse[],
): ProfileComparisonSection {
  const values = <T>(pick: (profile: PricingStrategyProfileResponse) => T) =>
    profileValues(profiles, pick);
  return {
    id: 'gapRecency',
    titleKey: 'gapRecency',
    rows: [
      row(
        'gap-opt-in',
        'gapRule',
        'gapOptIn',
        'boolean',
        values((p) => p.gapPriceRule.requiresApartmentOptIn),
      ),
      row(
        'gap-length',
        'gapRule',
        'gapLength',
        'number',
        values((p) => p.gapPriceRule.maximumGapLength),
      ),
      row(
        'gap-within',
        'gapRule',
        'gapWithin',
        'number',
        values((p) => p.gapPriceRule.withinArrivalDays),
      ),
      row(
        'gap-value',
        'gapRule',
        'gapValue',
        'percent',
        values((p) => p.gapPriceRule.adjustmentPercent),
      ),
      row(
        'recency-kind',
        'bookingRecency',
        'recencyKind',
        'text',
        values((p) => p.bookingRecencyPolicy.contributionKind),
      ),
      row(
        'recency-days',
        'bookingRecency',
        'recencyDays',
        'number',
        values((p) => p.bookingRecencyPolicy.minimumOfferedOperatingDays),
      ),
      row(
        'recency-events',
        'bookingRecency',
        'recencyEvents',
        'number',
        values((p) => p.bookingRecencyPolicy.minimumRegularBookingEvents),
      ),
    ],
  };
}
